// Token utility functions for sign-in-less interviews

/**
 * Validates the format of an access token (InterviewSlot ID)
 * @param {string} token - The token to validate
 * @returns {boolean} True if the token format is valid
 */
export const isValidTokenFormat = (token) => {
  if (!token || typeof token !== 'string') {
    return false;
  }
  
  // Check if it's a valid UUID format (InterviewSlot IDs are UUIDs)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(token);
};

/**
 * Creates a public interview URL for a given access token (InterviewSlot ID)
 * @param {string} accessToken - The access token (InterviewSlot ID)
 * @param {string} baseUrl - The base URL of the application (optional, defaults to current origin)
 * @returns {string} The complete public interview URL
 */
export const createPublicInterviewUrl = (accessToken, baseUrl = window.location.origin) => {
  return `${baseUrl}/public-interview/${accessToken}`;
};

/**
 * Token status constants - using existing InterviewSlot status values
 */
export const TOKEN_STATUS = {
  ACTIVE: 'SCHEDULED',   // Active interview - ready to be taken
  USED: 'COMPLETED',     // Interview has been completed/used  
  EXPIRED: 'CANCELLED'   // Interview link has expired or been cancelled
};

/**
 * Validates if a token status is valid
 * @param {string} status - The status to validate
 * @returns {boolean} True if the status is valid
 */
export const isValidTokenStatus = (status) => {
  return Object.values(TOKEN_STATUS).includes(status);
};
